import { alpha, Typography, useTheme } from "@mui/material";
import {
  ResponsiveContainer,
  CartesianGrid,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
  Line,
} from "recharts";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { CardBodyCore } from "src/Pages/components/CardCore/Components/CardBodyCore";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { IValueProfitDashboard } from "../Hooks/UseFormMonthByMonthProfitChart";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { Children } from "react";
interface IDashboardValues {
  valueProfitDashboard: IValueProfitDashboard | undefined;
}

interface TooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: {
      installmentNumber?: string;
      value?: number;
      dateReceived: string;
    };
    name: string;
    value: number;
  }>;
  labelStyle?: React.CSSProperties;
}

const CustomTooltip: React.FC<TooltipProps> = ({
  active,
  payload,
  labelStyle,
}) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const data = payload[0].payload;

  return (
    <CardCore>
      <Typography style={labelStyle}>
        {`Data do recebimento: ${FormatDateBR(data.dateReceived)}`}
      </Typography>

      <Typography style={labelStyle} mb={2}>
        {`Parcela: ${data.installmentNumber}`}
      </Typography>

      {Children.toArray(
        payload.map((item) => {
          return (
            <Typography>
              {`${item.name}: R$ ${
                Number(item.value) < 0
                  ? `- ${FormatMoney(String(Number(item.value)))}`
                  : FormatMoney(String(Number(item.value)))
              }`}
            </Typography>
          );
        })
      )}
    </CardCore>
  );
};

export const DashboardValues = (data: IDashboardValues) => {
  const theme = useTheme();
  const { valueProfitDashboard } = data;
  if (!valueProfitDashboard) return null;

  if (valueProfitDashboard.data.length < 3) {
    valueProfitDashboard.data.unshift({
      commissionValue: 0,
      valuePayment: 0,
      dateReceived: "",
      id: 0,
      installmentNumber: 0,
      lives: 0,
    });
  }

  const colorStroke = "#b8b8b8";

  return (
    <CardCore sxStyle={{ margin: "1rem 0", marginBottom: "24px" }}>
      <CardBodyCore title="Mensalidades | Lucros">
        <ResponsiveContainer height={350} width="100%">
          <LineChart data={valueProfitDashboard.data}>
            <XAxis // barra de baixo
              dataKey="dateReceived"
              fontSize={14}
              stroke={colorStroke}
              tickFormatter={(value) => FormatDateBR(value)}
            />

            <YAxis // barra lateral com valores
              fontSize={12}
              stroke={colorStroke}
              tickFormatter={(value) => FormatMoney(String(value))}
              type="number"
            />

            <CartesianGrid // grid
              stroke={alpha(colorStroke, 0.7)}
              strokeDasharray="3 3"
            />

            <Tooltip // tooltip
              labelStyle={{ color: colorStroke }}
              content={<CustomTooltip />}
            />

            <Line
              dot
              dataKey="valuePayment"
              fill="url(#colorPv)"
              name="Mensalidade"
              stroke={theme.palette.primary.main}
              strokeWidth={2}
              type="bump"
            />
            <Line
              name="Lucro"
              dot
              dataKey="commissionValue"
              fill="url(#colorPv2)"
              stroke={"#82ca9d"}
              strokeWidth={2}
              type="bump"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardBodyCore>
    </CardCore>
  );
};
